var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"config":_vm.config,"surveillance":_vm.surveillance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }